import React, { useState } from 'react';

const ContactUsContent = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission
    alert('Thank you for your message! We will get back to you soon.');
    setFormData({ name: '', email: '', subject: '', message: '' });
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <main className="p-6 dark:bg-gray-900 transition-colors duration-300">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm dark:shadow-gray-900/50 p-8 transition-colors duration-300">
          <h1 className="text-3xl font-bold text-gray-800 dark:text-white mb-6 flex items-center transition-colors duration-300">
            <i className="fa-solid fa-envelope mr-3 text-blue-600 dark:text-blue-400 transition-colors duration-300"></i>
            Contact Us
          </h1>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div>
              <h2 className="text-xl font-semibold text-gray-800 dark:text-white mb-4 transition-colors duration-300">Get in Touch</h2>
              <p className="text-gray-600 dark:text-gray-300 mb-6 transition-colors duration-300">
                Have questions or need support? We're here to help. Reach out to us through any of the following channels.
              </p>

              <div className="space-y-4">
                <div className="flex items-start">
                  <div className="bg-blue-100 dark:bg-blue-900/30 rounded-full p-3 mr-4 transition-colors duration-300">
                    <i className="fa-solid fa-phone text-blue-600 dark:text-blue-400 transition-colors duration-300"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-800 dark:text-white mb-1 transition-colors duration-300">Telepon / WhatsApp</h3>
                    <a 
                      href="https://wa.me/6281218268490" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-sm text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 hover:underline font-medium transition-colors duration-300"
                    >
                      +62 812-1826-8490
                    </a>
                    <p className="text-xs text-gray-600 dark:text-gray-400 mt-1 transition-colors duration-300">Klik untuk menghubungi via WhatsApp</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="bg-blue-100 dark:bg-blue-900/30 rounded-full p-3 mr-4 transition-colors duration-300">
                    <i className="fa-solid fa-location-dot text-blue-600 dark:text-blue-400 transition-colors duration-300"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-800 dark:text-white mb-1 transition-colors duration-300">Alamat</h3>
                    <p className="text-sm text-gray-600 dark:text-gray-300 transition-colors duration-300">
                      Harapan Jaya<br />
                      Kota Bekasi, Jawa Barat
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-6 pt-6 border-t border-gray-200 dark:border-gray-700 transition-colors duration-300">
                <h3 className="font-semibold text-gray-800 dark:text-white mb-3 transition-colors duration-300">Website</h3>
                <div className="flex items-center">
                  <div className="bg-blue-100 dark:bg-blue-900/30 rounded-full p-3 mr-4 transition-colors duration-300">
                    <i className="fa-solid fa-globe text-blue-600 dark:text-blue-400 transition-colors duration-300"></i>
                  </div>
                  <div>
                    <a 
                      href="https://dssolution.id/" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 hover:underline font-medium transition-colors duration-300"
                    >
                      https://dssolution.id/
                    </a>
                    <p className="text-xs text-gray-600 dark:text-gray-400 mt-1 transition-colors duration-300">Kunjungi website kami untuk informasi lebih lanjut</p>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <h2 className="text-xl font-semibold text-gray-800 dark:text-white mb-4 transition-colors duration-300">Send us a Message</h2>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 transition-colors duration-300">
                    Name *
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white transition-colors duration-300"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 transition-colors duration-300">
                    Email *
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white transition-colors duration-300"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 transition-colors duration-300">
                    Subject *
                  </label>
                  <input
                    type="text"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white transition-colors duration-300"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 transition-colors duration-300">
                    Message *
                  </label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="5"
                    className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white transition-colors duration-300"
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="w-full bg-blue-600 hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-600 text-white font-medium py-2 px-4 rounded-lg transition-colors duration-300"
                >
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default ContactUsContent;

